import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoClick as trackPostCommitmentInfoClick } from "@faire/web-api--source/events/zipCodeProtection/click/retailerExclusivityPostCommitmentInfo";
import { trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoView as trackPostCommitmentInfoView } from "@faire/web-api--source/events/zipCodeProtection/view/retailerExclusivityPostCommitmentInfo";
import { QueryParameters as BrandQueryParams } from "@faire/web-api--source/routes/brand/brandToken";
import { QueryParameters as CheckouQueryParams } from "@faire/web-api--source/routes/checkout/success/orderToken";
import { QueryParameters as MyBrandsQueryParams } from "@faire/web-api--source/routes/my-brands";
import { QueryParameters as ProductQueryParams } from "@faire/web-api--source/routes/product/productToken";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ExclusivityDetailsModal } from "./ExclusivityDetailsModal";
export var ExclusivityDetailsLink = function(param) {
    var agreementToken = param.agreementToken, brandToken = param.brandToken, origin = param.origin, color = param.color, children = param.children;
    var exclusivity_agreement_details = useQueryParams(PARSING_FUNCTIONS[origin]).exclusivity_agreement_details;
    var history = useHistory();
    var location = useLocation();
    var newQueryParams = new URLSearchParams(location.search);
    useEffect(function() {
        trackPostCommitmentInfoView(agreementToken !== null && agreementToken !== void 0 ? agreementToken : "", origin);
    }, [
        agreementToken,
        origin
    ]);
    if (agreementToken) {
        newQueryParams.append("exclusivity_agreement_details", agreementToken);
    }
    var linkTo = {
        pathname: location.pathname,
        search: newQueryParams.toString()
    };
    var isDetailsModalOpen = exclusivity_agreement_details === agreementToken;
    var handleClose = function() {
        history.goBack();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: linkTo,
                "data-test-id": "exclusivity-link",
                tertiaryColor: color,
                style: {
                    display: "inline"
                },
                onClick: function() {
                    return trackPostCommitmentInfoClick(agreementToken !== null && agreementToken !== void 0 ? agreementToken : "", origin);
                },
                children: children
            }),
            isDetailsModalOpen ? /*#__PURE__*/ _jsx(ExclusivityDetailsModal, {
                origin: origin,
                agreementToken: exclusivity_agreement_details !== null && exclusivity_agreement_details !== void 0 ? exclusivity_agreement_details : "",
                brandToken: brandToken,
                onClose: handleClose
            }) : null
        ]
    });
};
var PARSING_FUNCTIONS = {
    brand: BrandQueryParams.parse,
    "my-brands": MyBrandsQueryParams.parse,
    product: ProductQueryParams.parse,
    "post-checkout": CheckouQueryParams.parse,
    "my-orders": function() {
        return {};
    }
};
